import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { DashboardWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class DashboardCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_DASHBOARDS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Dashboards
                    </NavLink>
                </li>
                <li>New Dashboard</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Dashboard'}
                        subTitle={'Create a new dashboard'}
                        paths={this.renderHeaderPaths}
                    />
                    <DashboardWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { DashboardCreatorPage }
